import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=b356ef0a&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=b356ef0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b356ef0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b356ef0a')) {
      api.createRecord('b356ef0a', component.options)
    } else {
      api.reload('b356ef0a', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=b356ef0a&scoped=true&", function () {
      api.rerender('b356ef0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8C5fXYXnf7g1o/JS/comp/DateRange.vue"
export default component.exports